var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-element-loading',{attrs:{"active":_vm.isLoading,"is-full-screen":"","text":"Please wait..."}}),_c('div',[_c('lineChart',{staticClass:"chart-height",attrs:{"chart-data":_vm.lineChartData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }